






















import { Component, Vue, Prop } from 'vue-property-decorator'
import InputHelperTextComponent from './InputHelperTextComponent.vue'

@Component({
  components: {
    InputHelperTextComponent
  }
})

export default class InputFieldNumberComponent extends Vue {
  @Prop() public fields!: number;
  @Prop() public error!: boolean;
  @Prop() public errorMsg?: string;
  @Prop() public info?: boolean;
  @Prop() public infoMsg?: string;

  public input: string[] = [];

  public switchFocus (index: number) {
    if (this.$refs.inputfield[index].value !== '') {
      if (index === this.fields - 1) {
        this.$refs.inputfield[index].blur()
        this.$emit('inputUpdate', this.input.join(''))
      }
      this.$refs.inputfield[index + 1].focus()
    }
  }

  public onKeyDown (event: KeyboardEvent, index: number) {
    if (event.key === 'Backspace' && this.$refs.inputfield[index].value === '') {
      // event.preventDefault()
      this.$refs.inputfield[index - 1].focus()
    } else {
      if (this.input[index].length > 0) {
        this.$refs.inputfield[index].value = this.input[index].slice(0, 0)
      }
    }
  }

  public handlePaste (event: ClipboardEvent) {
    event.preventDefault()
    const pastedText = event.clipboardData?.getData('text') || ''
    const pastedTextArray = [...pastedText]
    let index = 0
    pastedTextArray.forEach((char: string) => {
      if (char >= '0' && char <= '9') {
        this.$refs.inputfield[index].value = char
        this.input[index] = char
        this.switchFocus(index)
        index++
      }
    })
  }

  public focusOnFirstField () {
    this.input = []
    this.$refs.inputfield[0].focus()
    this.$emit('inputUpdate', this.input.join(''))
  }
}
